import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { css, useTheme } from "@emotion/react";

import useBreakpoint from "core/hooks/useBreakpoint";
import { AUTH_LOGIN_URL } from "core/includes/pricingAuthRedirects";

import RoundTextButton from "core/Components/Buttons/RoundTextButton";
import CartIcon from "core/Components/Navigations/CartIcon";
import { HOME_USER_URL } from "core/config/config";

type Props = {
    menuButton?: Button,
    hideCart?: boolean,
};

const NavLinkButtons:React.FC<Props> = ({ menuButton = undefined, hideCart = false }) => {
    const theme = useTheme();
    const { minWidth } = useBreakpoint();
    const linkURL = menuButton?.innerURL || menuButton?.outerURL;

    const [
        sidePaddingGetStart,
        sidePaddingLogin,
        buttonWidth,
        buttonHeight,
        buttonFontSize,
    ] = useMemo(() => {
        switch (true) {
            case minWidth >= theme.breakpoints.sizes["3xl"]:
                return [10, 10, 109, 36, 15];
            default:
                return [10, 10, 109, 36, 14];
        }
    }, [minWidth, theme.breakpoints.sizes]);

    const style = css`
        flex-direction: row;
        display: flex;
    `;

    return (
        <div css={style}>
            {!hideCart && (
                <CartIcon to={menuButton?.cartURL || ''} />
            )}

            {(menuButton?.buttonText && linkURL) && (
                <NavLink to={linkURL}>
                    <RoundTextButton
                        sidePadding={sidePaddingGetStart}
                        minWidth={buttonWidth}
                        height={buttonHeight}
                        fontSize={buttonFontSize}
                        textColour={"black"}
                        backgroundColour={theme.colours.gold}
                        backgroundHoverColour={theme.colours.mySin}
                        useBoxShadow={false}
                        noButtonBorderHover
                    >
                        {menuButton.buttonText}
                    </RoundTextButton>
                </NavLink>
            )}

            <NavLink key={"/login"} to={`${HOME_USER_URL}${AUTH_LOGIN_URL}`}>
                <RoundTextButton
                    sidePadding={sidePaddingLogin}
                    width={buttonWidth}
                    height={buttonHeight}
                    fontSize={buttonFontSize}
                    textColour={theme.colours.white}
                    backgroundColour={theme.colours.curiousBlue}
                    backgroundHoverColour={theme.colours.malibu3}
                    buttonBorder={1}
                    useBoxShadow={false}
                    noButtonBorderHover
                >
                    Log in
                </RoundTextButton>
            </NavLink>
        </div>
    );
};

export default NavLinkButtons;